import { render, staticRenderFns } from "./DealerOTPManagement.vue?vue&type=template&id=21dbf9db&scoped=true&"
import script from "./DealerOTPManagement.vue?vue&type=script&lang=js&"
export * from "./DealerOTPManagement.vue?vue&type=script&lang=js&"
import style0 from "./DealerOTPManagement.vue?vue&type=style&index=0&id=21dbf9db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dbf9db",
  null
  
)

export default component.exports